module.exports = __webpack_public_path__ + "static/media/FOLDING_BUCKLE.27c66377.svg";